var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"alert-modal"},[_c('div',{staticClass:"modal-close-button",on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("✖")]),_c('b-row',{staticClass:"modal-body-wrapper"},[_vm._t("default")],2),_c('b-row',{staticClass:"modal-btns"},[_vm._t("buttons")],2)],1),_c('div',{staticClass:"modal-overlay"})])
}
var staticRenderFns = []

export { render, staticRenderFns }